export enum ScreensAddMessage {
  SuccessAdd = 'Screen "{name}" successfully created',
}
